// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hb8E7Y {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-3);
}

.BDITEW {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1);
}

.UMBTD4 {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--spacing-0-5);
}

.keho5U {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.tk_fy1 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.Cnno6c {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  border-radius: var(--radius-s);
  border: 1px solid var(--surface-neutral-subtle);
}

.BCuAeC {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: var(--spacing-1);
  align-self: stretch;
}

.xWXIoR {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
}

.pSmAgF {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 1.421;
  color: var(--text-neutral-dark);
  text-align: left;
  margin-bottom: var(--spacing-0-5);
}

.Ze32Yf {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--spacing-1-5);
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--surface-neutral-silver);
  border-radius: var(--radius-s);
  align-self: stretch;
}

.lAfjdH {
  flex: 1;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  word-break: break-all;
  text-align: left;
}

.fs0M4S {
  width: var(--spacing-2);
  height: var(--spacing-2);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
}

.fs0M4S svg {
  width: var(--spacing-2);
  height: var(--spacing-2);
  color: var(--text-neutral-stronger);
}

.ejmkTH {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  align-self: stretch;
}

.xhDNSo {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  width: fit-content;
  margin: 0;
  align-items: flex-start;
}

._hgJ7R {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-1);
  align-self: stretch;
  width: 100%;
  min-width: 160px;
}

.Y3rOZ2 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: 1.424;
  color: var(--text-neutral-dark);
  text-align: left;
  margin: 0;
}

.i1L0oZ {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1);
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  border-radius: var(--radius-s);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--brand-tr-orange);
  width: auto;
  flex-shrink: 0;
}

._uiEaR {
  width: 14px;
  height: 14px;
  color: var(--brand-tr-orange);
}

.lgOAv3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 160px;
  border-radius: var(--radius-s);
  background-color: var(--background-white);
}

.lgOAv3 svg {
  width: 160px !important;
  height: 160px !important;
}

.S6M5MB {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--text-neutral-strong);
  font-size: 48px;
  background-color: #f0f0f0;
  text-align: center;
  gap: var(--spacing-1);
}

.G4jKih {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-strong);
  text-align: center;
  margin-top: var(--spacing-1);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargesCreated/ChargesCreated.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;EAC7C,+CAA+C;EAC/C,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,6BAA6B;EAC7B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;EACjC,kBAAkB;EAClB,4BAA4B;AAC9B","sourcesContent":[".step {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-3);\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.mediumSemiboldText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.mediumRegularText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.billetDataRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  border-radius: var(--radius-s);\n  border: 1px solid var(--surface-neutral-subtle);\n}\n\n.fieldsContainer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--spacing-1);\n  align-self: stretch;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n}\n\n.fieldLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 1.421;\n  color: var(--text-neutral-dark);\n  text-align: left;\n  margin-bottom: var(--spacing-0-5);\n}\n\n.fieldContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1-5);\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--surface-neutral-silver);\n  border-radius: var(--radius-s);\n  align-self: stretch;\n}\n\n.fieldValue {\n  flex: 1;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  word-break: break-all;\n  text-align: left;\n}\n\n.copyButton {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.copyButton svg {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  color: var(--text-neutral-stronger);\n}\n\n.qrContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  align-self: stretch;\n}\n\n.qrGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  width: fit-content;\n  margin: 0;\n  align-items: flex-start;\n}\n\n.qrHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--spacing-1);\n  align-self: stretch;\n  width: 100%;\n  min-width: 160px;\n}\n\n.qrTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: 1.424;\n  color: var(--text-neutral-dark);\n  text-align: left;\n  margin: 0;\n}\n\n.downloadPdfButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1);\n  height: 24px;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--brand-tr-orange);\n  width: auto;\n  flex-shrink: 0;\n}\n\n.downloadIcon {\n  width: 14px;\n  height: 14px;\n  color: var(--brand-tr-orange);\n}\n\n.qrCode {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 160px;\n  height: 160px;\n  border-radius: var(--radius-s);\n  background-color: var(--background-white);\n}\n\n.qrCode svg {\n  width: 160px !important;\n  height: 160px !important;\n}\n\n.qrPlaceholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: var(--text-neutral-strong);\n  font-size: 48px;\n  background-color: #f0f0f0;\n  text-align: center;\n  gap: var(--spacing-1);\n}\n\n.qrPlaceholderText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-strong);\n  text-align: center;\n  margin-top: var(--spacing-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step": `Hb8E7Y`,
	"column": `BDITEW`,
	"row": `UMBTD4`,
	"mediumSemiboldText": `keho5U`,
	"mediumRegularText": `tk_fy1`,
	"billetDataRow": `Cnno6c`,
	"fieldsContainer": `BCuAeC`,
	"field": `xWXIoR`,
	"fieldLabel": `pSmAgF`,
	"fieldContainer": `Ze32Yf`,
	"fieldValue": `lAfjdH`,
	"copyButton": `fs0M4S`,
	"qrContainer": `ejmkTH`,
	"qrGroup": `xhDNSo`,
	"qrHeader": `_hgJ7R`,
	"qrTitle": `Y3rOZ2`,
	"downloadPdfButton": `i1L0oZ`,
	"downloadIcon": `_uiEaR`,
	"qrCode": `lgOAv3`,
	"qrPlaceholder": `S6M5MB`,
	"qrPlaceholderText": `G4jKih`
};
module.exports = ___CSS_LOADER_EXPORT___;
